import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRightIcon, SettingsIcon } from 'lucide-react';
import { AvisAtna } from '../components/avis/AvisAtna';
import { ImportantForYou } from '../components/avis/ImportantForYou';
import { NoticeFeed, type NoticeFilter } from '../components/avis/NoticeFeed';
export function AvisNotifications() {
  const [filter, setFilter] = useState<NoticeFilter>('Tous');
  const handleChip = (chip: string) => {
    if (chip === 'Mes alertes importantes') setFilter('Importants');
    if (chip === 'Non lus') setFilter('Non lus');
    if (chip === 'Cette semaine') setFilter('Tous');
  };
  return <main className="bg-white" data-id="element-2027" data-mp="382jy7yl2r0m4">
      <div className="mx-auto max-w-[1000px] px-5 py-12 lg:px-10 lg:py-16" data-id="element-2028" data-mp="3c4drvmwur4cs">
        <nav aria-label="Fil d’Ariane" className="flex items-center gap-1.5 text-sm text-slate-500" data-id="element-2029" data-mp="3c2au2gpgk6xi">
          <Link to="/" className="font-semibold text-ville-deep hover:text-ville-indigo" data-id="element-2030" data-mp="3mr5vw3n9epb">
            Accueil
          </Link>
          <ChevronRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-2031" data-mp="1o6pm6kdbvn4y" />
          <span aria-current="page" data-id="element-2032" data-mp="1o4wdkzj5msub">Notifications</span>
        </nav>

        <header className="mt-4 flex flex-wrap items-end justify-between gap-4" data-id="element-2033" data-mp="1j97gd2ulxo16">
          <div data-id="element-2034" data-mp="1xxu33pmkdi2f">
            <h1 className="text-4xl font-extrabold tracking-tight text-ville-navy lg:text-5xl" data-id="element-2035" data-mp="1xydaicel8o27">
              Notifications
            </h1>
            <p className="mt-2 text-[17px] text-slate-600" data-id="element-2036" data-mp="26xgv5ktelbit">Restez informé de ce qui vous concerne.</p>
          </div>
          <Link to="/notifications/parametres" className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-bold text-ville-navy transition-colors duration-150 ease-ville hover:border-ville-indigo hover:text-ville-indigo focus:outline-none focus-visible:ring-2 focus-visible:ring-ville-indigo" data-id="element-2037" data-mp="22wessv46wjcm">
            <SettingsIcon className="h-4 w-4" aria-hidden="true" data-id="element-2038" data-mp="hiirlso17gdi" />
            Paramètres
          </Link>
        </header>

        <div className="mt-8" data-id="element-2039" data-mp="2hlbictovs18w">
          <AvisAtna onFilter={handleChip} data-id="element-2040" data-mp="2hm3dy4ih9yz6" />
        </div>

        <ImportantForYou data-id="element-2041" data-mp="2mjljrm177y2y" />
        <NoticeFeed filter={filter} onFilterChange={setFilter} data-id="element-2042" data-mp="2mkwj99nm2jo9" />
      </div>
    </main>;
}